import { Button, Flex, Typography } from "antd"

export const TopUpStepUI = () => {
  return (
    <Typography.Text>
      In the Balances section, select the currency you want to top up and click
      the Top Up button to add funds to your balance.
    </Typography.Text>
  )
}
